/**
 * 用户管理
 */
import React from "react";
import TreeAndTableLayout from "../../../../components/TreeAndTableLayout/TreeAndTableLayout";
import UserListToolBar from "./UserListToolBar/UserListToolBar";
import UserTableOperation from "./UserTableOperation/UserTableOperation";
import { formatDateByFmt, treeForEach, generateTreeData, filterForEach, getCurrentUser } from "../../../../utils";
import BaseComponent from "../../../../base/BaseComponent";
import EditUserModal from "./editUserModal/EditUserModal";
import ResetPwdModal from "./resetPwd/ResetPwdModal";
import "../../style/sysManagement.css";
import { message } from "../../utils/sysManagementUtils";
import ContentWrap from "../../components/ContentWrap";
import { Popover } from "antd";
import { Scrollbars } from "react-custom-scrollbars";
import {setInfoToLocalStorage,loadCurrentUser} from "../../../../actions";
import {connect} from "react-redux";

const currentUser = getCurrentUser();

class UserList extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            roleOption: [],
            treeDataIndex: {
                id: "id",
                title: "name",
                children: "child",
                key: "id"
            },

            selectedKeys: [],
            treeData: [],
            deptIds: [],
            searchValue: "",
            ifContainSonDept: 1,

            pageSize: 10,
            currentPage: 1,
            columns: [],

            count: 0,
            tableData: [],
            tableIsLoading: false,
            selectedRowKeys: [],
            selectedRows: [],

            expandedKeys: [],
            autoExpandParent: true,

            editUserModalVisible: false,
            editData: null,
            resetPwdModalVisible: false,
            webSiteDataSource: [],// 网站绑定数据
            disableAllDept: false,
            level: "2",
        };
    }

    componentDidMount() {
        this.queryUserByCondition();
        this.getPasswordLevel();
        this.initData();
        this.deptGetTree();
    }

    render() {
        const {
            treeData,
            pageSize,
            currentPage,
            columns,
            tableData,
            tableIsLoading,
            count,
            searchValue,
            ifContainSonDept,
            selectedRowKeys,
            selectedRows,
            selectedKeys,
            expandedKeys,
            autoExpandParent,
            editData,
            resetPwdModalVisible,
            editUserModalVisible
        } = this.state;
        return (
            <ContentWrap>
                <TreeAndTableLayout
                    treeData={treeData}
                    selectedKeys={selectedKeys}
                    autoExpandParent={autoExpandParent}
                    onExpand={this.onExpand}
                    expandKey={this.expandKey}
                    onSelect={this.onTreeSelect}
                    expandedKeys={expandedKeys}
                    showIcon={true}
                    pageSize={pageSize}
                    current={currentPage}

                    count={count}
                    columns={columns}
                    tableData={tableData}
                    tableIsLoading={tableIsLoading}
                    showRowSelection={true}
                    rowSelection={{
                        selectedRowKeys,
                        onChange: this.onRowSelectionChange,
                        onSelectAll: this.onTableSelectAll
                    }}
                    ToolBar={
                        <UserListToolBar
                            searchValue={searchValue}
                            selectedRowKeys={selectedRowKeys}
                            selectedRows={selectedRows}
                            onSearch={this.onSearch}
                            onSearchValueChange={this.onSearchValueChange}
                            ifContainSonDept={ifContainSonDept === 1}
                            onContainSonDeptChange={this.onContainSonDeptChange}
                            updateTable={this.queryUserByCondition}
                            showEditUserModal={() => this.showEditUserModal(null)}
                        />
                    }
                    onChange={this.onPageChange}
                    onShowSizeChange={this.onShowSizeChange}
                />
                {/*编辑用户弹窗*/}
                <EditUserModal
                    visible={editUserModalVisible}
                    title={editData ? "修改用户" : "添加用户"}
                    handleOk={this.submitEditUserModal}
                    handleCancel={this.hideEditUserModal}
                    data={editData}
                    webSiteDataSource={editData ? this.state.webSiteDataSource : []}
                    selectedKeys={(()=>{
                            if(selectedKeys[0]==="0" && window.currentUser.account !== "admin") {
                                return [treeData?.[0]?.children?.[0]?.id]
                            }
                            return selectedKeys
                        })()}
                    refresh={()=>{this.getWebSiteBindUserList(editData)}}
                    disableAllDept={this.state.disableAllDept}
                    level={this.state.level}
                />

                {/*重置密码*/}
                <ResetPwdModal
                    visible={resetPwdModalVisible}
                    handleOk={this.submitResetPwdModal}
                    handleCancel={this.hideResetPwdModal}
                />

            </ContentWrap>
        );
    }

    /**
     * 重置密码
     * @param pwd
     */
    submitResetPwdModal = pwd => {
        message.destroy();
        const { editData: { id } } = this.state;
        this.resetPwdRequest({ id, pwd }, res => {
            if (res) {
                message.success("用户密码已被重置");
                this.hideResetPwdModal();
                this.queryUserByCondition();
            }
        });
    };

    /**
     * 退出重置密码
     */
    hideResetPwdModal = () => {
        this.setState({
            resetPwdModalVisible: false
        });
    };
    /**
     * 进入重置密码
     * @param editData
     */
    showResetPwdModal = editData => {
        this.setState({
            resetPwdModalVisible: true,
            editData
        });
    };
    /**
     * 进入编辑用户
     * @param editData
     */
    showEditUserModal = editData => {
        if (!editData) {
            this.state.disableAllDept = true
        }
        this.setState({
            editUserModalVisible: true,
            editData
        });
        if(editData){
            this.getWebSiteBindUserList(editData);
        }
    };
    // 获取数据
    getWebSiteBindUserList = (editData) => {
        this.request({
            url: "/cm-sites-pms/website/getWebSiteBindUserList",
            body: {userId: editData.id},
            callBack: (res) => {
                // console.log(res);
                let webSiteDataSource = [];
                if (res) {
                    webSiteDataSource = res;
                }
                this.setState({webSiteDataSource})
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        });
    };
    // 获取密码强度
    getPasswordLevel = () => {
        this.request({
            url: '/cm-sites-sys/user/getCurrentLevel',
            callBack: (res) => {
                if (res) {
                    this.setState({level: res})
                }
            }
        })
    };
    /**
     * 退出用户编辑
     */
    hideEditUserModal = () => {
        this.setState({
            editUserModalVisible: false
        });
    };
    /**
     * 提交用户编辑/新增
     * @param user
     */
    submitEditUserModal = user => {
        if (user.id) {
            this.updateUser(user);
        } else {
            this.addUser(user);
        }
    };
    /**
     * 设置展开
     * @param expandedKeys
     */
    onExpand = expandedKeys => {
        this.setState({
            expandedKeys,
            autoExpandParent: false
        });
    };

    /**
     * 展开某一个节点
     * @param key
     */
    expandKey = key => {
        const { expandedKeys, treeData } = this.state;
        const tree = filterForEach(treeData, node => {
            return node.id === key;
        });
        const keys = [];
        treeForEach(tree, node => {
            keys.push(node.id);
        });
        this.setState({
            expandedKeys: [...(new Set([...expandedKeys, ...keys]))],
            autoExpandParent: false
        });
    };

    /**
     * 树选择是调用
     * @param selectKeys
     */
    onTreeSelect = (selectKeys) => {
        this.setState({
            currentPage: 1,
            searchValue:"",
            deptIds: selectKeys,
            selectedKeys: selectKeys,
            ifContainSonDept:1
        }, () => {
            this.queryUserByCondition();
        });
    };

    /**
     * 当页码变换的回调
     * @param page
     * @param pageSize
     */
    onPageChange = (page, pageSize) => {
        this.setState({
            currentPage: page,
            pageSize: pageSize
        }, () => {
            this.queryUserByCondition();
        });
    };

    /**
     * pageSize 变化的回调
     * @param current
     * @param size
     */
    onShowSizeChange = (current, size) => {
        this.setState({
            pageSize: size,
            currentPage: 1
        }, () => {
            this.queryUserByCondition();
        });
    };

    onSearch = () => {
        console.log(1)
        this.setState({
            currentPage: 1,
            ifContainSonDept:1
        }, () => {
            this.queryUserByCondition();
        });
    };

    onSearchValueChange = searchValue => {
        this.setState({ searchValue });
    };

    // 包含子节点
    onContainSonDeptChange = checked => {
        this.setState({
            ifContainSonDept: checked ? 1 : 0
        }, () => {
            this.queryUserByCondition();
        });
    };

    //  表格选择行时的回调
    onRowSelectionChange = (selectedRowKeys, selectedRows) => {
        this.setState({
            selectedRowKeys: [...selectedRowKeys],
            selectedRows: [...selectedRows]
        });
    };

    //  表格选择行时的回调
    onTableSelectAll = (selected) => {
        const { tableData } = this.state;
        if (selected) {
            this.setState({
                selectedRowKeys: tableData.map(item => item.id),
                selectedRows: [...tableData]
            });
        } else {
            this.setState({
                selectedRowKeys: [],
                selectedRows: []
            });
        }
    };

    initData = () => {
        const columns = [
            {
                title: "姓名",
                dataIndex: "name",
                width: 140,
                ellipsis: true,
                render: (text, record) => {
                    return <span onClick={() => this.showEditUserModal(record)} style={{color:'#0050B3',cursor: 'pointer'}}>{text}</span>;
                }
            },
            {
                title: "账号",
                dataIndex: "account",
                width: 120,
                ellipsis: true
            },
            {
                title: "角色",
                dataIndex: "roleList",
                width: 160,
                render: text => {
                    let roleStr = text.map(item=>item.roleName).join(",");
                    if (roleStr.length > 7) {
                        roleStr = roleStr.slice(0, 7) + "...";
                    }
                    return <div className={'userListName'}>
                        {
                            roleStr.length > 7 ?
                                <Popover
                                    getPopupContainer={triggerNode => triggerNode.parentNode}
                                    content={
                                        <div style={{ maxWidth: "30vw", display: "inline-block" }}>
                                            <Scrollbars className="cm-scrollbars" autoHeight={true} autoHeightMax="200px">
                                            <div style={{paddingBottom:"0px",display:"flex",flexWrap:"wrap"}}>
                                                {text.map(item => {
                                                    return <div
                                                        style={{  paddingRight: "20px",paddingBottom:"5px", whiteSpace: "nowrap" }}
                                                        key={item.roleName}>{item.roleName}</div>;
                                                })}
                                            </div>
                                            </Scrollbars>
                                        </div>
                                    }
                                    title="角色"
                                    trigger="hover"
                                >
                                    {roleStr}
                                </Popover> : roleStr
                        }
                    <style>
                        {`
                            .userListName .ant-popover-inner-content{
                                padding:12px 16px 0 16px;
                            }
                        `}
                    </style>
                    </div>;
                }
            },
            {
                title: "部门",
                dataIndex: "deptList",
                width: 180,
                render: text => {
                    let deptStr = text.map(item=>item.name).join("，");
                    if (deptStr.length > 7) {
                        deptStr = deptStr.slice(0, 7) + "...";
                    }
                    return <>
                        {
                            deptStr.length > 7 ?
                                <Popover
                                    content={
                                        <div style={{ maxWidth: "30vw", display: "inline-block" }}>
                                             <Scrollbars autoHeight={true} autoHeightMax="200px">
                                                {text.map(item => {
                                                    return <div
                                                        style={{ float: "left", paddingRight: "20px", whiteSpace: "nowrap" }}
                                                        key={item.name}>{item.name}</div>;
                                                })}
                                            </Scrollbars>
                                        </div>
                                    }
                                    title="用户部门"
                                    trigger="hover"
                                >
                                    {deptStr}
                                </Popover> : deptStr
                        }

                    </>;
                }
            },
            {
                title: "修改密码时间",
                dataIndex: "prevUpdatePWDTime",
                width: 180,
                ellipsis: true,
                render: (text, record) => {
                    text = text ? text : record.createTime
                    return text ? formatDateByFmt(text, "yyyy-MM-dd hh:mm:ss") : ""
                }
            },
            {
                title: "操作",
                width: 200,
                render: (text, record) => {
                    return <UserTableOperation
                        record={record}
                        showResetPwdModal={() => this.showResetPwdModal(record)}
                        updateTable={this.queryUserByCondition}
                    />;
                }
            }
        ];

        this.setState({
            columns
        });
    };

    queryUserByCondition = () => {
        const { pageSize, currentPage, searchValue, deptIds, roleOption, ifContainSonDept } = this.state;
        const params = {
            accountOrName: searchValue,
            deptIds,
            roleOption,
            ifContainSonDept,
            start: currentPage,
            size: pageSize
        };
        this.setState({
            tableIsLoading: true
        });
        this.queryUserByConditionRequest(params, res => {
            const { data, count } = res;

            if (count !== 0 && count <= (currentPage - 1) * pageSize) {
                this.onPageChange(currentPage - 1, pageSize);
            } else {
                this.setState({
                    tableData: data,
                    count,
                    tableIsLoading: false,
                    selectedRowKeys: [],
                    selectedRows: []
                });
            }
        });
    };

    deptGetTree = () => {
        const { selectedKeys } = this.state;
        this.deptGetTreeRequest(res => {
            // 格式化树数据
            const treeData = generateTreeData([res], this.state.treeDataIndex);
            // 首次请求设置激活的树id  并展开所有的树
            if (!selectedKeys.length) {
                const expandedKeys = [];
                treeForEach(treeData, node => {
                    if (node.children && node.children.length) {
                        expandedKeys.push(node.id);
                    }
                });
                this.setState({
                    selectedKeys: [treeData[0].id],
                    deptIds: [treeData[0].id],
                    expandedKeys,
                    treeData
                });
            }
            this.setState({
                treeData
            });
        });
    };

    updateUser = data => {
        this.updateUserRequest(data, res => {
            if (res) {
                // message.success({content:"用户信息成功更新",duration:1,onClose:()=>window.location.reload()});
                message.success("用户信息成功更新");
                this.queryUserByCondition();
                this.hideEditUserModal();
                if(data.id==window.currentUser.id){
                    this.props.loadCurrentUser((data) => {
                        let currentUser = {...data}
                        if (data.defaultInfo && data.defaultInfo.dept) {
                            currentUser.deptIds = [data.defaultInfo.dept.id]
                            currentUser.deptList = [data.defaultInfo.dept];
                            let roleList = data.defaultInfo.roleList || [];
                            let roleCodes = [];
                            roleList.forEach(role => {
                                roleCodes.push(role.roleCode)
                            })
                            currentUser.roleCodes = roleCodes;
                            currentUser.roleList = roleList;
                        }
                        window.currentUser = currentUser;
                        setInfoToLocalStorage("currentUser", currentUser);
                        setInfoToLocalStorage("permissionsUserAccount", data.account);
                    })
                }
            }
        });
    };

    addUser = user => {
        this.addUserRequest(user, res => {
            if (res) {
                this.setState({
                    currentPage: 1
                }, () => {
                    message.success("用户添加成功");
                    this.queryUserByCondition();
                    this.hideEditUserModal();
                })
            }
        });
    };

    deptGetTreeRequest = (callBack) => {
        this.request({
            url: "/cm-sites-sys/dept/getTree",
            body: { id: 0 },
            callBack
        });
    };

    queryUserByConditionRequest = ({ accountOrName, deptIds, roleOption, ifContainSonDept, start, size }, callBack) => {
        this.request({
            url: "/cm-sites-sys/user/conditionQuery",
            method: "post",
            body: {
                accountOrName, deptIds, roleOption, ifContainSonDept, start, size
            },
            contentType: "json",
            callBack
        });
    };

    updateUserRequest = ({ id, account, name, deptIds, roleCodes, sex, photoUrl, tel, phone,deptRoles } = {}, callBack) => {
        this.request({
            url: "/cm-sites-sys/user/update",
            method: "post",
            contentType: "json",
            body: {
                id,
                account,
                name,
                deptIds,
                roleCodes,
                sex,
                photoUrl,
                tel,
                phone,
                deptRoles
            },
            callBack
        });
    };

    addUserRequest = ({ account, name, deptIds, roleCodes, password, age, sex, photoUrl, status, tel, phone,deptRoles}, callBack) => {
        const body = {
            account: account,
            name: name,
            deptIds,
            roleCodes,
            age,
            sex,
            photoUrl,
            status,
            tel,
            phone,
            deptRoles
        };
        // 没有密码回使用默认密码
        password = password || "";
        if(password&&password.length){
            let passAndPublicKey = window.encryption(password);
            body.password = passAndPublicKey.pass;
            body.publicKey = passAndPublicKey.publicKey;
        }
        this.request({
            url: "/cm-sites-sys/user/add",
            method: "post",
            contentType: "json",
            body,
            callBack
        });
    };

    resetPwdRequest = ({ id, pwd }, callBack) => {
        let passAndPublicKey = window.encryption(pwd);
        this.request({
            url: "/cm-sites-sys/user/resetPwd",
            method: "post",
            body: { id, pwd: passAndPublicKey.pass, publicKey: passAndPublicKey.publicKey },
            callBack
        });
    };
}
function mapStateToProps(state) {
    return {
        currentUser: state.systemReducer.currentUser,
    }
}
function mapStateToMethod(state) {
    return {
        loadCurrentUser: function (callBack, errorCallBack) {
            return state(loadCurrentUser(callBack, errorCallBack));
        },
    }
}
export default connect(mapStateToProps, mapStateToMethod)(UserList)
